import { createRouter, createWebHistory, RouteRecordRaw } from "vue-router";
import Home from '@/views/website/Home.vue';
import Investidor from '@/views/website/PaginaInvestidor.vue';
import Incorporador from '@/views/website/PaginaIncorporador.vue';
import Ajuda from '@/views/website/Ajuda.vue';
import PaginaProjeto from '@/views/website/PaginaProjeto.vue';
import PaginaInvestimento from '@/views/website/PaginaInvestimento.vue';
import Login from '@/views/website/Login.vue';
import PaginaCalculadora from '@/views/website/PaginaCalculadora.vue';
import NotFound from '@/views/website/NotFound.vue'
import { authentication } from "@/services/Authentication";
import PaginaRating from "@/views/website/PaginaRating.vue";
import { OSPA_CAPITAL_LANDING_URL } from "@/utils/ospa";

const routes: Array<RouteRecordRaw> = [
  {
    path: "/",
    name: "Home",
    component: Home
  },
  {
    path: "/investidor/",
    name: "Investidor",
    component: Investidor
  },
  {
    path: "/incorporador/",
    name: "Incorporador",
    component: Incorporador,
    props: true,
    meta: {
      externalRedirect: OSPA_CAPITAL_LANDING_URL,
    }
  },
  {
    path: "/ajuda/",
    name: "Ajuda",
    component: Ajuda
  },
  {
    path: "/calculadora/",
    name: "Calculadora",
    component: PaginaCalculadora,
    meta: {
      externalRedirect: OSPA_CAPITAL_LANDING_URL,
    }
  },
  {
    path: "/calculadora/rating/:hashRating/",
    name: "Rating",
    component: PaginaRating,
    meta: {
      externalRedirect: OSPA_CAPITAL_LANDING_URL,
    }
  },
  {
    path: "/incorporador/:incorporadoraSlug/:projetoSlug",
    name: "Projeto",
    component: PaginaProjeto,
  },
  {
    path: "/investimento/:incorporadoraSlug/:projetoSlug/:captacaoSlug",
    name: "Investimento",
    component: PaginaInvestimento,
    meta: {
      requiresAuth: true,
    }
  },
  {
    path: "/login",
    name: "Login",
    component: Login,
    meta: {
      noTemplate: true
    },
    props: true,
  }
];

const router = createRouter({
  history: createWebHistory('/'),
  routes
});

router.beforeEach((to, from) => {
  // Rotas aposentadas (captação de incorporador / calculadora): saem da SPA para
  // o OSPA capital. Precisa vir antes de qualquer outra guarda — o vue-router
  // resolveria a navegação no cliente e o redirect do Django nunca aconteceria.
  const externalRedirect = to.meta.externalRedirect as string | undefined;
  if (externalRedirect) {
    // href e não replace(): o return false abaixo cancela a navegação, então a
    // rota aposentada nunca chega a entrar no histórico — replace() apagaria a
    // página de onde o usuário saiu e o "voltar" não traria ele de volta.
    window.location.href = externalRedirect;
    return false;
  }

  if (to.meta.requiresAuth && !authentication.isAuthenticated()) {
    return {
      name: "Login",
      query: {
        next: to.path,
        internal: 'true'
      }
    }
  }

  if (to.name == 'Login') {
    to.query.next = from.path;
    to.query.internal = 'true';
  }
})

export default router;